/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

export enum ReportsTableToolbarActionTypes {
  ADD_REPORT,
  REFRESH_TABLE,
  SELECT_SOURCE_DATASETS,
  SAVE_TABLE,
  BULK_DELETE_REPORTS
}

export enum ReportsTableRowActionTypes {
  VIEW_REPORT,
  EDIT_REPORT,
}
